import {
  getNavIdFromTitle,
  GridCol,
  GridContainer,
  GridRow,
  Icon,
  ICONS,
  mixins,
} from '@bob/library'
import Heading from '@websrc/App/Components/Heading/Heading'
import { getAnchorPropsFromLink } from '@websrc/App/Helpers/getAnchorPropsFromLink'
import { useLocale } from '@websrc/App/Hooks/useLocale'
import { mapModularSelectorSpot } from '@websrc/DataMappers/mapSpot'
import { SpotLinkAnchor } from '@websrc/Spot/Link/SpotLinkAnchor'
import { SpotLinkButton } from '@websrc/Spot/Link/SpotLinkButton'
import { _typography } from 'leds'
import React from 'react'

import { LearnMoreButtonType } from '../Collapse/SpotCollapse'
import * as SC from './SpotModularSelector.style'

export interface SpotModularSelectorProps {
  spot: ReturnType<typeof mapModularSelectorSpot>['modular_selector']
  LearnMoreButton?: LearnMoreButtonType
  isTopOfPage?: boolean
}

export function SpotModularSelector({
  spot,
  LearnMoreButton,
  isTopOfPage,
}: SpotModularSelectorProps) {
  const wrapperProps = {
    id: spot.left_item.caption ? getNavIdFromTitle(spot.left_item.caption) : undefined,
  }

  const locale = useLocale()
  const thumbnailUrl = spot.left_item.asset.thumbnail?.url

  return (
    <GridContainer>
      <GridRow {...wrapperProps}>
        <GridCol desktop={6}>
          <SC.LeftSide url={thumbnailUrl}>
            <SC.LeftTextWrapper>
              <Heading
                headline={spot.left_item.headline}
                level={isTopOfPage ? 1 : 2}
                noSpacing={true}
                size={'xl'}
                style={{ color: mixins.colors.grayWhite }}
              />
              {LearnMoreButton && (
                <SC.LearnMoreButtonWrapper>
                  <LearnMoreButton />
                </SC.LearnMoreButtonWrapper>
              )}
              {spot.left_item.link.cta_text && (
                <SpotLinkAnchor
                  ctaType={'tertiary'}
                  ctaVariant={'white'}
                  link={spot.left_item.link}
                >
                  <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                  <span>{spot.left_item.link.cta_text}</span>
                </SpotLinkAnchor>
              )}
            </SC.LeftTextWrapper>
          </SC.LeftSide>
        </GridCol>

        <SC.RightSide desktop={6}>
          {spot.right_items.map((item, i) => {
            const anchorProps = getAnchorPropsFromLink(item.right_link, locale)

            return (
              <SC.RightItem {...anchorProps} key={i} numberOfItems={spot.right_items.length}>
                <Heading
                  description={item.description}
                  headline={item.headline}
                  level={isTopOfPage ? 2 : 3}
                  size={'s'}
                />
                <SpotLinkButton ctaType={'tertiary'} link={item.right_link}>
                  <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                  <span>{item.right_link.cta_text}</span>
                </SpotLinkButton>
              </SC.RightItem>
            )
          })}
        </SC.RightSide>
      </GridRow>
    </GridContainer>
  )
}
